import { render, staticRenderFns } from "./DeptPositionEdit.vue?vue&type=template&id=3504f918"
import script from "./DeptPositionEdit.vue?vue&type=script&lang=js"
export * from "./DeptPositionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports